/* eslint-disable prefer-destructuring */
/**

Coded by www.techhighway.ca

*/

// @mui material components
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";

export default styled(Checkbox)(({ theme, ownerState }) => {
  const { palette, functions } = theme;
  const { disabled } = ownerState;
  const { grey, transparent } = palette;

  return {
    "& .MuiCheckbox-root input": {
      backgroundColor: "#fff",
    },
  };
});
